import React from "react";
import {
    Heading,
    ListItem,
    List,
    Text
} from "spectacle";
import Button from '../components/Button';

const OurSolutionOptimization = () =>
    <div>
        <Heading size={6} textColor="secondary" caps>
            Our Solution - AI POWERED SLIDES
        </Heading>
        <Text textSize={30} textColor="primary">
            Optimize the lead to revenue journey
        </Text>
        <List ordered textColor="secondary" style={{ paddingLeft: '25px', listStylePosition: 'outside' }}>
            <ListItem textSize={25}>Peronalize slide content</ListItem>
            <ListItem textSize={25}>Track engagement on shared slide decks</ListItem>
            <ListItem textSize={25}>Track behavior in slide decks, e.g. which slides is the prospect most interested in</ListItem>
            <ListItem textSize={25}>Recommend slides to include based on industry, role and company size, etc.</ListItem>
            <ListItem textSize={25}>Give sales leaders intelligence about their sales teams’ performance, in real-time.</ListItem>
            <ListItem textSize={25}>Essentially, bring full-fledge web analytics to slide decks</ListItem>
        </List>
    </div>

export default OurSolutionOptimization;






// WEBPACK FOOTER //
// ./src/slides/OurSolutionOptimization.js